import axios from 'axios';

export const DELETE_DRAFT_BEGIN = 'DELETE_DRAFT_BEGIN';
export const DELETE_DRAFT_SUCCESS = 'DELETE_DRAFT_SUCCESS';
export const DELETE_DRAFT_FAILURE = 'DELETE_DRAFT_FAILURE';

export const deleteDraftBegin = () => ({
    type: DELETE_DRAFT_BEGIN
});

export const deleteDraftSuccess = (value) => ({
    type: DELETE_DRAFT_SUCCESS,
    payload: value
});

export const deleteDraftFailure = (error) => ({
    type: DELETE_DRAFT_FAILURE,
    payload: error
});

export const deleteDraftASF = (webappurlForms, accessToken, recordid) => {
    return dispatch => {
        const data = {
            recordid: recordid
        };

        const options = {
            headers: {
                'Authorization': "Bearer " + accessToken,
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            }
        };

        dispatch(deleteDraftBegin());
        
        return axios.post(webappurlForms + "/api/myCASA/Forms/DeleteDraft/v1", data, options)
            .then(() => {               
                return dispatch(deleteDraftSuccess());                
            })
            .catch(error => {
                return dispatch(deleteDraftFailure(error.response ? error.response.data.errors : error));
            });
    }
}

export const deleteDraftAEM = (url, deleteLink) => {
    return dispatch => {

        const options = {
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            },
            withCredentials: true
        };

        //move to action
        return axios.get(url, null, options)
            .then(response => {
                const optionsDel = {
                    headers: {
                        'Accept': 'application/json',
                        'Content-Type': 'application/json; charset=utf-8',
                        'X-CSRF-TOKEN': response.data.token,
                        'Csrf-Token': response.data.token
                    },
                    withCredentials: true
                };
                axios.delete(deleteLink, optionsDel)
                    .then(() => {
                        setTimeout(function () {
                            location.assign("/forms/indmanagerpa?droneregdeleted=1");
                        }, 10000);
                    })
                    .catch(() => {
                        location.assign("/error?code=MRPAI.1");
                    });
            })
            .catch(() => {
                location.assign("/error?code=MRPAI.1");
            });
    }
}
